<script lang="ts">
	import {Wizard} from './wizard';
	import Button from "./Button.svelte";
	import StepperBox from "./StepperBox.svelte";
	import {ASSET_URL} from "../config";
	import {createEventDispatcher} from "svelte";
	import { _ } from '../services/i18n';

	export let currentStep: number;
	export let reportType: string;
	export let goTo: (step: number) => void;
	const dispatch = createEventDispatcher<{
		goTo: number
	}>();

	function goToStep(step: number) {
		dispatch('goTo', step);
	}

</script>
<!-- Step {currentStep} of {numSteps} -->
<Wizard bind:currentStep bind:goTo={goTo} let:nextStep let:previousStep let:numSteps>
	<StepperBox stepText="{ $_('pagination', { values: {current: currentStep,total:numSteps}})}" title="{ $_('title')}{currentStep > 1 ? ` - ${reportType}` : ''}">
		<Button slot="left" href={currentStep <= 1 ? '/' : null} on:click={previousStep}>
			<img slot="start-icon" alt="" src="{ASSET_URL}/assets/arrow-back.svg">
			{$_('backBtn')}
		</Button>
		<slot {currentStep} ></slot>

		<ol slot="bottom" class="stepper-dots">
			{#each {length: numSteps} as _, step}
				{#if step + 1 === currentStep}
					<li style="width: {100 / (numSteps + 1)}%">
						<button type="button"
								aria-current="true"
								 on:click={() => goToStep(step + 1)}
								aria-label="Step [{step + 1}]"
								class="stepper-dot is-selected"
						></button>
					</li>
				{:else}
					<li style="width: {100 / (numSteps + 1)}%">
						<button type="button"
								 on:click={() => goToStep(step + 1)}
								aria-label="Step [{step + 1}]"
								class="stepper-dot"
						></button>
					</li>
				{/if}
			{/each}
		</ol>
	</StepperBox>
</Wizard>

<style lang="scss">
	img {
		max-width: fit-content !important;
		margin: 0 !important;
	}
	.stepper-dots {
		//display: flex;
		margin: 0;
		padding:0;
		text-align: center;
		list-style-type: none;
	}

	li{

		display: inline-block;
		position: relative;
	}

	.stepper-dot {
		display: inline-block;
		height: 10px;
		position: relative;

		&:not(.is-selected) {
			cursor: pointer;
			height:10px;
			top:2px;
		}
	}
	.stepper-dot:before {
		transform: scale(1);
		box-shadow: none;
		width: 90%;
		height: 10px;
		border-radius: 100px;
		display: block;
		content: '';
		position: absolute;
		//top: 13px;
		left: 0;
		border: solid #DE1125 3px;
		//margin-left: 11px;
		//opacity:0.25;
		//background-color: #C8C8C8;
	}
	.stepper-dot.is-selected:before {
		background-color: #DE1125;
		//opacity: 100;
		height:15px;


	}

	.stepper-dot:not(.is-selected):hover::before{
		background-color: #DE1125;
		height:15px;
		top:2.5px;
	}

	.stepper-dot.is-selected:hover::before{
		height:15px;
		top:5px;
	}



	button{

		width: 100%;
		height: 30px;
		color: transparent;
		background:transparent;
		border:0;



	}
</style>
